export default __webpack_public_path__ + "static/lea-tablet-0e879d4953092617068772514f70729f.png";